import React, { useState, useEffect } from "react";
import MetaTags from "react-meta-tags";
import {
  Card,
  CardBody,
  Col,
  Container,
  Label,
  Row,
  Form,
  Button,
  CardTitle,
  Input,
  FormFeedback,
  UncontrolledTooltip,
} from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";

// Redux
import { connect, useDispatch } from "react-redux";
import { withRouter, useHistory, Link, useParams } from "react-router-dom";

// Backend
import { getConsignmentDetail } from "connection/backend";

// actions
import { consignmentUpdate } from "store/actions";

//Import Breadcrumb
import Breadcrumb from "components/Common/Breadcrumb";
import Loader from "components/Common/Loader";

const ConsignmentUpdate = (props) => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const redirect = () => {
    history.push("/consignments");
  };

  const getData = async (id) => {
    const response = await getConsignmentDetail(id);
    const data = response.data;
    setFormData({
      client: data.client,
      full_name: data.full_name,
      payment_method: data.payment_method,
      value: data.value,
      created_date: data.created_date,
    });
  };

  useEffect(() => {
    getData(id);
  }, []);

  const [formData, setFormData] = useState({
    client: "",
    full_name: "",
    payment_method: "",
    value: "",
    created_date: "",
  });

  const { client, full_name, payment_method, value, created_date } = formData;

  const [formData1, setFormData1] = useState({
    cancelled: true,
    cancellation_reason: "",
  });

  const { cancellation_reason } = formData1;

  const onChange = (e) => {
    setFormData1({ ...formData1, [e.target.name]: e.target.value });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    cancellation_reason !== "" ? setAlert(true) : setAlert(false);
  };

  const [alert, setAlert] = useState(false);

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Carnesvilla | Consignaciones </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={"Carnesvilla"} breadcrumbItem={"Consignaciones"} />
          {props.loading ? (
            <Loader />
          ) : (
            <div className="d-flex justify-content-center">
              {alert ? (
                <SweetAlert
                  title="¿Está seguro/a de cancelar la consignación?"
                  warning
                  showCancel
                  confirmBtnText="Sí"
                  confirmBtnBsStyle="success"
                  cancelBtnText="No"
                  cancelBtnBsStyle="danger"
                  onConfirm={() => {
                    setAlert(false);
                    dispatch(consignmentUpdate(id, formData1));
                  }}
                  onCancel={() => setAlert(false)}
                >
                  Luego de cancelada no se puede recuperar.
                </SweetAlert>
              ) : null}
              {props.consignmentUpdated.id ? (
                <SweetAlert
                  title="¡Hecho!"
                  success
                  showConfirm={true}
                  onConfirm={() => {
                    redirect();
                  }}
                >
                  La consignación se ha cancelado correctamente.
                </SweetAlert>
              ) : null}
              <Card
                style={{
                  width: "70rem",
                }}
              >
                <CardTitle className="ps-3 pt-3">
                  <h2 className="mb-3 font-size-20">
                    Cancelar consignación # {id}
                  </h2>
                </CardTitle>
                <CardBody>
                  <Form>
                    <Row className="justify-content-md-center">
                      <Col lg={7}>
                        <p>Información de la consignación</p>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={2}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Código"
                              name="client"
                              id="client"
                              value={client}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="client">Código</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={5}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-id-card bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Nombre completo"
                              name="full_name"
                              id="full_name"
                              value={full_name}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="full_name">Nombre completo</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center">
                      <Col lg={2}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-calendar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Fecha"
                              name="created_date"
                              id="created_date"
                              value={created_date}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="created_date">Fecha</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={3}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-money bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Medio de pago"
                              name="payment_method"
                              id="payment_method"
                              value={payment_method}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="payment_method">Medio de pago</Label>
                          </div>
                        </div>
                      </Col>
                      <Col lg={2}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-dollar bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="text"
                              className="form-control"
                              placeholder="Valor"
                              name="value"
                              id="value"
                              value={value.toLocaleString("es-CO")}
                              disabled
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="value">Valor</Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </Form>
                  <Form onSubmit={onSubmit}>
                    <Row className="justify-content-md-center">
                      <Col lg={7}>
                        <div className="input-group mb-3">
                          <span className="input-group-text">
                            <i className="bx bx-note bx-sm" />
                          </span>
                          <div className="form-floating">
                            <Input
                              type="textarea"
                              className="form-control"
                              placeholder="Motivo de la cancelación"
                              name="cancellation_reason"
                              id="cancellation_reason"
                              value={cancellation_reason}
                              onChange={onChange}
                              required
                            />
                            <FormFeedback tooltip></FormFeedback>
                            <Label for="payment_method">
                              Motivo de cancelación
                            </Label>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <Row className="justify-content-md-center mt-4 ms-5">
                      <Col lg={3}>
                        <Link
                          className="btn btn-danger me-4"
                          to="/consignments"
                        >
                          Volver
                        </Link>

                        <Button
                          color="success"
                          type="submit"
                        >
                          Enviar
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  );
};

const mapStateToProps = (state) => {
  const { error, loading, consignmentUpdated } = state.Payment;
  return { error, loading, consignmentUpdated };
};

export default withRouter(connect(mapStateToProps)(ConsignmentUpdate));
